var _rect, _path, _g, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOnGoingOrderActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M10.369 21.903H.917v-20h18v6.455h-1.492V3.39H2.408v17.026h7.96Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.277 7.961H4.937v-1.5h10.34ZM8.898 12.74H4.937v-1.5h3.961ZM8.898 17.519H4.937v-1.5h3.961Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFC72C",
  stroke: "#FFC72C",
  strokeWidth: 1.5,
  transform: "translate(10.901 9.998)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.091,
  cy: 6.091,
  r: 6.091,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6.091,
  cy: 6.091,
  r: 5.341,
  fill: "none"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "m14.815 18.415 3.835-1.483V13.61h-1.652v2.3l-2.715 1.073Z"
})));
export { SvgOnGoingOrderActive as ReactComponent };
export default "/_next/static/images/on_going_order-active.svg";